import { useEffect, useState } from "react";

const compute = (width) => {
  if (width >= 1440) return 5;
  if (width >= 1200) return 4;
  if (width >= 1024) return 3;
  if (width >= 768) return 4;
  if (width >= 540) return 3;
  return 2;
};

export default function useChipVisibleCount() {
  const [count, setCount] = useState(() => {
    if (typeof window === "undefined") return 4;
    return compute(window.innerWidth);
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    let frame = null;
    const onResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        setCount(compute(window.innerWidth));
      });
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return count;
}
